(ns teamoesterreich.admin-mode.lebensretter.detail.lna-part

  (:require [clojure.string]
            [goog.date.DateTime]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            ))

(defn form [!lna lnaActive]
  [mui/box
   [mui/typography {:variant "subtitle1" :style {:padding-right "3rem" :font-weight 700}} "LNA-Einsätze"]
   [mui/form-control-label
    {
     :style   {:background-color (if (not= lnaActive @!lna) "#ffd6d2" "transparent")}
     :label   "Berechtigt (österreichweit)"
     :control (r/as-element
                [mui/checkbox {:color    "primary"
                               :checked  (or @!lna false)
                               :onChange (fn [_ val]
                                           (reset! !lna val))
                               }])
     }
    ]
   ])

